enum IncomeChartClass {
    FinalSalary = "FinalSalary",
    OtherIncome = "OtherIncome",
    ConsumedTotalOtherIncome = "ConsumedTotalOtherIncome",
    ConsumedTotalOtherInvestments = "ConsumedTotalOtherInvestments",
    ConsumedTotalFinalSalaries = "ConsumedTotalFinalSalaries",
    ConsumedStatePension = "ConsumedStatePension",
    AggregateExpensesWithoutTaxAsExpense = "AggregateExpensesWithoutTaxAsExpense",
    Savings = "Savings",
    DefinedContDrawdown = "DefinedContDrawdown",
    Deficit = "Deficit",
    Tax = "Tax",
    SavingsDisinvestments = "SavingsDisinvestments",
    DefinedContContingency = "DefinedContContingency",
    DefinedContPotLessContingency = "DefinedContPotLessContingency",
    WhatYouCanGetAfterTax = "WhatYouCanGetAfterTax"
}

export default IncomeChartClass;
